export enum PaymentTargetEnum {
	RENTAL_RESERVATION = 'rental_reservation',
	RENTAL_AGREEMENT = 'rental_agreement',
	TRANSACTION = 'transaction',
}
